export const GET_LINKS = 'bookLinks/GET_LINKS';
export const CLEAR_LINKS = 'bookLinks/CLEAR_LINKS';
